import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from "rxjs/operators";

import {AuthService} from '../services/auth.service';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService, public loaderService: LoaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.auth.token;
    if (authToken != null) {
      this.loaderService.show();
      const authReq = request.clone({
        headers: request.headers.set('Authorization', 'Bearer' +  authToken)
      });
      return next.handle(authReq).pipe(
        finalize(() => this.loaderService.hide())
      );
    }
    return next.handle(request).pipe(
      finalize(() => this.loaderService.hide())
    );
  }
}
